import { AirDirectionDTO } from "../api/response.types";
import { AirAirlineNameDTO, AirReferenceDTO, AirStatusesModel } from "entities/shared/airCard.types";
import { ValueOf } from "shared/lib/typeCheck.lib";

export type AirReferenceModel = AirReferenceDTO;

export type AirAirlineNameModel = AirAirlineNameDTO;

export type AirDirectionModel = Omit<AirDirectionDTO, "country_code" | "iata_code" | "icao_code" | "nearest_city"> & {
  countryCode: string | null;
  iataCode: string | null;
  icaoCode: string | null;
  nearestCity: string | null;
};

export type CountByAirStatusModel = {
  status: ValueOf<typeof AirStatusesModel>;
  count: number;
};
